import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Crown } from 'lucide-react';
export function FinalCTA() {
  const scrollToOffer = () => {
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-10 px-5 pb-28" data-id="element-89">
      {' '}
      {/* Extra padding bottom for sticky CTA */}
      <div className="max-w-lg mx-auto text-center" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="border border-gold-500/30 p-6 sm:p-8 rounded-sm relative" data-id="element-91">
          <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-navy-900 px-3 text-gold-400" data-id="element-92">
            <Crown size={20} data-id="element-93" />
          </div>

          <h2 className="font-serif text-2xl text-cream-100 mb-4 mt-1" data-id="element-94">
            Estás a un paso
          </h2>

          <div className="space-y-1 text-[14px] text-cream-300/80 font-light mb-5" data-id="element-95">
            <p data-id="element-96">No necesitas estar lista.</p>
            <p data-id="element-97">No necesitas tener todo resuelto.</p>
            <p data-id="element-98">No necesitas entender todo el camino.</p>
            <p className="text-gold-400 font-serif text-lg italic pt-1" data-id="element-99">
              Solo necesitas estar dispuesta.
            </p>
          </div>

          <Button fullWidth onClick={scrollToOffer} className="mb-4" data-id="element-100">
            Quiero mi devocional — Estoy dispuesta
          </Button>

          <p className="text-[10px] text-cream-300/50 uppercase tracking-widest" data-id="element-101">
            Comienza tu proceso hoy. 12 días. Una revelación. Tu momento.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.5
      }} className="mt-8" data-id="element-102">
          <p className="font-serif text-base text-cream-300/60 italic" data-id="element-103">
            "Hay momentos en la vida que no llegan por casualidad. Llegan con
            propósito."
          </p>
          <p className="text-xs text-gold-500/50 mt-1" data-id="element-104">
            — Odalia Morán Arévalo
          </p>
        </motion.div>
      </div>
    </section>;
}